import React, { useEffect, useState } from 'react';
import { ChevronRight } from 'lucide-react';

import { useCustomNavigate } from '../../hooks';
import { useCustomSelectors } from '../../services/selectors/allSelectors';

import Cookies from 'js-cookie';
import InitatedChatBox from './initatedChatBox';

import * as routNames from '../../routes/routeName';
const getValidPhoto = (photo) => {
	const value = String(photo || '').trim();
	return value && !['null', 'undefined'].includes(value.toLowerCase()) ? value : '';
};

const getChatUserPhoto = (value) => getValidPhoto(value?.pharmacistUser?.photo) || getValidPhoto(value?.driverUser?.photo) || getValidPhoto(value?.thumbnail);

const getInitials = (value) => {
	const name = String(value || '').trim();
	if (!name) return 'U';

	const parts = name.split(/\s+/).filter(Boolean);
	if (parts.length === 1) {
		return parts[0].slice(0, 2).toUpperCase();
	}

	return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const getChatUserName = (value) => value?.name || value?.pharmacistUser?.name || value?.driverUser?.name || value?.email || value?.pharmacistUser?.email || value?.driverUser?.email || 'User';

const ChatUserAvatar = ({ value }) => {
	const [imageFailed, setImageFailed] = useState(false);
	const photo = getChatUserPhoto(value);
	const shouldShowImage = photo && !imageFailed;

	if (shouldShowImage) {
		return (
			<img
				src={photo}
				onError={() => setImageFailed(true)}
				alt=""
				className='object-cover bg-light'
			/>
		);
	}

	return (
		<span className="support-chat-list-avatar-fallback">
			{getInitials(getChatUserName(value))}
		</span>
	);
};


export const ContactList = ({
	openChatbox,
	employeesOnlineStatus,
	selectedEmployeeId,
	setMyInputMessages,
	setChatAppenedMessages,
	setChatInput,
	setAllGroupMessages,
	allGroupMessages,
	chatInput,
	myInputMessages,
	chatAppenedMessages,
	openOverlay,
	closeOverlay,
	chatLoading,
	setSelectedEmployeeId,
	setPage,
	page,
	inline = false
}) => {

	const { profileData, chatUserList, chatUsers } = useCustomSelectors()
	const [chatValue, setChatValue] = useState(null);

	const chatListsUser = chatUsers?.data?.data

	useEffect(() => {
		// console.log(chatUsers.data.data)
	}, [chatUsers])

	return (
		<>
			{(!inline || !selectedEmployeeId) && (
			<div className="support-chat-thread-list">
				{
					chatLoading ? <div className="support-chat-loading">Loading...</div>
						:
						chatListsUser?.length === 0 ?
							<div>
								<h4 className="rubik-500 fs-16 dark-color">
									No results found.
								</h4>
							</div>
							:
							chatUserList?.error !== null ?
								<div>
									<h4 className="rubik-500 fs-16 dark-color">
										Something Went wrong please try again later.
									</h4>
								</div>
								:
								chatListsUser?.map((value, index) => {

									return (
										<React.Fragment key={index}>
											{profileData?.user_id === value?.pharmacist_id ? null :
												<>
													<button
														type="button"
														className={`support-chat-thread ${selectedEmployeeId === value?.id ? 'is-active' : ''}`}
														onClick={() => {
															setChatValue(value);
															openChatbox(value, 'contact_list');
														}}
													>
														<div className="support-chat-thread-main">
															<div className="support-chat-list-avatar">
																<ChatUserAvatar value={value} />
															</div>
															<div className="support-chat-thread-copy">
																<div className="support-chat-thread-row">
																	<span className="support-chat-thread-title">{value.name}</span>
																</div>
																<div className="support-chat-thread-meta-line">
																	<span className="support-chat-thread-preview">Joined at {value?.pharmacistUser?.join_at || value?.driverUser?.join_at}</span>
																</div>
															</div>
														</div>
														<ChevronRight size={13} className="support-chat-thread-chevron" />
													</button>
												</>}</React.Fragment>

									)
								})
				}
			</div>
			)}
			
			<InitatedChatBox
				value={chatValue}
				selectedEmployeeId={selectedEmployeeId}
				profileData={profileData}
				employeesOnlineStatus={employeesOnlineStatus}
				setMyInputMessages={setMyInputMessages}
				setChatAppenedMessages={setChatAppenedMessages}
				setChatInput={setChatInput}
				setAllGroupMessages={setAllGroupMessages}
				allGroupMessages={allGroupMessages}
				chatInput={chatInput}
				myInputMessages={myInputMessages}
				chatAppenedMessages={chatAppenedMessages}
				openOverlay={openOverlay}
				closeOverlay={closeOverlay}
				setSelectedEmployeeId={setSelectedEmployeeId}
				setPage={setPage}
				page={page}
				inline={inline}
				onBack={() => setSelectedEmployeeId(null)}
			/>
		</>
	)
}


export const ResponsiveContactList = ({
	chatLoading,
}) => {

	const { profileData, chatUserList } = useCustomSelectors()
	const navigate = useCustomNavigate()

	return (
		<>
			<div className="support-chat-thread-list">
				{
					chatLoading ? <div className="support-chat-loading">Loading...</div>
						:
						chatUserList?.data?.data?.length === 0 ?
							<div>
								<h4 className="rubik-500 fs-16 dark-color">
									No results found.
								</h4>
							</div>
							:
							chatUserList?.error !== null ?
								<div>
									<h4 className="rubik-500 fs-16 dark-color">
										Something Went wrong please try again later.
									</h4>
								</div>
								:
								chatUserList?.data?.data?.map((value, index) => {
									return (
										<React.Fragment key={index}>
											{
												profileData?.user_id === value?.user_id ? null :
													<>
														<button
															type="button"
															className="support-chat-thread"
															onClick={() => { return navigate(`${routNames.CHAT_NOW}/${value.user_id}`), Cookies.remove('previous') }}
														>
															<div className="support-chat-thread-main">
																<div className="support-chat-list-avatar">
																	<ChatUserAvatar value={value} />
																</div>
																<div className="support-chat-thread-copy">
																	<div className="support-chat-thread-row">
																		<span className="support-chat-thread-title">{value.name}</span>
																	</div>
																</div>
															</div>
															<ChevronRight size={13} className="support-chat-thread-chevron" />
														</button>
													</>}
										</React.Fragment>

									)
								})}
			</div>
		</>
	)
}
